/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/Api';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const ApiIcon = withMuiAdapter(Base, 'Api');
